<template>
  <div>
    <v-card>
      <v-card-text>
        <v-layout row>
          <v-flex xs12 sm6 md4>
            <qrcode-stream :paused="paused" @decode="onDecode" @error="onError">
              <div v-show="showScanConfirmation" class="scan-confirmation">
                <img
                  :src="`${appUrl}/storage/img/checkmark.svg`"
                  alt="Checkmark"
                  width="128"
                />
              </div>
            </qrcode-stream>
          </v-flex>
          <v-flex xs12 sm6 md8>
            <v-layout row>
              <v-flex xs12 sm8 md8>
                <v-autocomplete
                  v-model="currentFamilySearch"
                  :items="familyResult"
                  :loading="isLoading"
                  :search-input.sync="searchFamily"
                  color="primary"
                  hide-no-data
                  hide-selected
                  item-text="name"
                  item-value="name"
                  placeholder="Buscar familia"
                  return-object
                  clearable
                  :error="inputSearchError"
                ></v-autocomplete>
              </v-flex>
              <v-flex xs12 sm4 md4>
                <v-btn
                  :loading="validatingFamily"
                  :disabled="!currentFamilySearch"
                  @click="virtualAssistance()"
                  large
                  color="primary"
                  >Tomar Asistencia</v-btn
                >
              </v-flex>
            </v-layout>
            <div
              class="family_info"
              v-show="parents.asopaf === 0 || parents.asopaf === 1"
            >
              <span class="asopaf_mark">
                <v-alert
                  :value="true"
                  :color="this.parents.asopaf === 1 ? 'error' : 'info'"
                  outline
                >
                  <b>ASOPAF:</b> {{ this.parents.asopaf === 1 ? "Si" : "No" }}
                </v-alert>
              </span>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>Familia:</b> {{ this.parents.name }}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>Padre:</b> {{ this.parents.father }}
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b>Madre:</b> {{ this.parents.mother }}
              <b v-if="currentFamilySearch"
                >Código: {{ currentFamilySearch.id }}
              </b>
              &nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;&nbsp;
              <b v-if="currentFamilySearch"
                ># Representados: {{ this.parents.powers_number }}</b
              >
            </div>
          </v-flex>
        </v-layout>
      </v-card-text>
    </v-card>
  </div>
</template>

<script>
import axios from "axios";
import { QrcodeStream } from "vue-qrcode-reader";

export default {
  name: "assembly-assistance-qr",
  components: { QrcodeStream },
  props: {
    idAssembly: {
      type: Number,
      required: true
    }
  },
  data() {
    return {
      appUrl: window.config.appUrl,
      entries: [],
      isLoading: false,
      currentFamilySearch: null,
      searchFamily: null,
      inputSearchError: false,
      parents: {},
      paused: false,
      showScanConfirmation: false,
      validatingFamily: false,
      result: ""
    };
  },
  methods: {
    onError: console.error,

    async onDecode(decodedString) {
      this.result = decodedString;

      if (this.result.length == 20) {
        axios
          .get(`/api/family/token/${this.result}/${this.idAssembly}`)
          .then(response => {
            const { data, status } = response;
            if (status === 200) {
              if (data.assistance) {
                this.currentFamilySearch = {
                  id: data.family.id_family,
                  name: data.family.user.name
                };
                this.$store.dispatch("responseMessage", {
                  type: "warning",
                  title: "Asistencia duplicada",
                  text: "Esta familia ya tiene asistencia en esta asamblea",
                  modal: true
                });
              } else {
                const payload = {
                  id: data.family.id_family,
                  id_assembly: this.idAssembly
                };
                axios
                  .post(`/api/assembly/virtual_assistance`, payload)
                  .then(res => {
                    this.currentFamilySearch = {
                      id: data.family.id_family,
                      name: data.family.user.name
                    };

                    this.showScanConfirmation = true;
                    this.paused = true;

                    setTimeout(() => {
                      this.paused = false;
                      this.showScanConfirmation = false;
                    }, 2000);
                  })
                  .catch(err => {
                    console.log(err);
                  });
              }
            }
            this.pageLoading = false;
          })
          .catch(error => {
            this.pageLoading = false;
            console.log(error);
          });
      } else {
        console.log("Invalid length");
      }
    },
    virtualAssistance() {
      const payload = {
        id: this.currentFamilySearch.id,
        id_assembly: this.idAssembly
      };
      axios
        .post(`/api/assembly/virtual_assistance`, payload)
        .then(res => {
          this.showScanConfirmation = true;

          setTimeout(() => {
            this.showScanConfirmation = false;
          }, 2000);
        })
        .catch(err => {
          console.log(err);
        });
    }
  },
  computed: {
    familyResult() {
      return this.entries.map(user => {
        user.name.length > this.userNameMaxLength
          ? user.name.slice(0, this.userNameMaxLength) + "..."
          : user.name;

        return Object.assign({}, user);
      });
    }
  },
  watch: {
    searchFamily(val) {
      this.parents = {};
      if (!val) {
        this.isLoading = false;
        return;
      }

      if (this.isLoading) return;

      this.isLoading = true;

      axios
        .get(`/api/assembly/search_family/${val}/${this.idAssembly}`)
        .then(res => {
          const { data } = res;
          this.count = data.length;
          this.entries = data;
        })
        .catch(err => {
          console.log(err);
        })
        .finally(() => (this.isLoading = false));
    },
    currentFamilySearch: function(newVal, oldVal) {
      if (newVal) {
        axios
          .get(`/api/family/parents/${newVal.id}/${this.idAssembly}`)
          .then(res => {
            if (res.status === 200) {
              this.parents = res.data;
            }
          })
          .catch(error => console.log(error));
        return;
      }
      this.parents = {};
    }
  }
};
</script>

<style scoped>
.scan-confirmation {
  position: absolute;
  width: 100%;
  height: 100%;

  background-color: rgba(255, 255, 255, 0.8);

  display: flex;
  flex-flow: row nowrap;
  justify-content: center;
}
</style>



// WEBPACK FOOTER //
// resources/assets/js/pages/assembly/qr_reader.vue